import PlainConfirmModal from 'app/common/ui-next/plain-confirm-modal'

type Props = {
  surveyTitle: string
  deleting: boolean
  onCancel: () => void
  onConfirm: () => void
}

export const DeleteSurveyConfirmModal = ({
  surveyTitle,
  deleting,
  onCancel,
  onConfirm,
}: Props) => (
  <PlainConfirmModal
    messageText={`Переместить опрос «${surveyTitle}» в архив? Его можно будет восстановить.`}
    cancelButtonTitle="Отмена"
    confirmButtonTitle={deleting ? 'Удаление…' : 'Удалить'}
    confirmButtonProps={{ disabled: deleting }}
    cancelButtonProps={{ disabled: deleting }}
    onCancel={onCancel}
    onConfirm={onConfirm}
    critical
  />
)
